import React from "react";

const getPaymentTypeText = (conditions) => {
  const raw = (
    conditions?.periodText ||
    conditions?.billingPeriod ||
    conditions?.period ||
    conditions?.interval ||
    conditions?.billing_interval ||
    ""
  )
    .toString()
    .toLowerCase();


  //Temp fix for Michelin
  if (
    raw === "" &&
    conditions?.conditions &&
    conditions?.conditions === "cover"
  )
    return "cover";

  if (raw.includes("year") || raw.includes("annual")) return "year";
  if (raw.includes("month") || raw.includes("monthly")) return "month";
  if (raw.includes("week") || raw.includes("weekly")) return "week";
  if (raw.includes("day") || raw.includes("daily")) return "day";
  return "month";
};

const CommercialConditions = ({ conditions, type, description }) => {
  const paymentTypeText = getPaymentTypeText(conditions);
  if (type === "meta") {
    return (
      <>
        <h2>Commercial Conditions & Fees</h2>
        {description ? (
          <p>{description}</p>
        ) : (
          <p>
            Increase your bookings by receiving online reservations directly
            from your restaurant page on the <strong>Meta</strong> apps and
            website.
          </p>
        )}
        <ul>
          <li>
            <strong>
              ${conditions.fullPrice / 100} {conditions.currency}
            </strong>{" "}
            per {paymentTypeText} excluding taxes.
          </li>
          <li>
            Payment and Invoice will be processed on the 10th of the month.
          </li>
        </ul>
      </>
    );
  }

  if (type === "michelin") {
    return (
      <>
        <h2>Commercial Conditions & Fees</h2>
        {description ? (
          <p>{description}</p>
        ) : (
          <p>
            Increase your bookings by receiving online reservations directly
            from your restaurant page on <strong>The MICHELIN Guide</strong>{" "}
            apps and website.
          </p>
        )}
        <ul>
          <li>
            <strong>
              ${conditions.fullPrice / 100} {conditions.currency}
            </strong>{" "}
            per {paymentTypeText} excluding taxes.
          </li>
          <li>
            Payment and Invoice will be processed on the 10th of the month.
          </li>
        </ul>
      </>
    );
  }

  if (type === "listing") {
    return (
      <>
        <h2>Commercial Conditions & Fees</h2>
        {description ? (
          <p>{description}</p>
        ) : (
          <p>
            Boost your restaurant’s online visibility and reach your target
            audience effectively with comprehensive listing and review
            management.
          </p>
        )}
        <ul>
          <li>
            <strong>
              ${conditions.fullPrice / 100} {conditions.currency}
            </strong>{" "}
            per {paymentTypeText} excluding taxes.
          </li>
          <li>
            Payment and Invoice will be processed on the 10th of the month.
          </li>
        </ul>
      </>
    );
  }

  if (type === "smartchannel") {
    return (
      <>
        <h2>Commercial Conditions & Fees</h2>
        {description ? (
          <p>{description}</p>
        ) : (
          <p>
            Increase your visibility and reach by receiving reservation from
            multiple booking channels.
          </p>
        )}
        <p>
          Booking receiver including a reservation widget for your website,
          Reserve with Google, Facebook & Instagram and Listing & Review.
        </p>
        <ul>
          <li>
            <strong>
              ${conditions.fullPrice / 100} {conditions.currency}
            </strong>{" "}
            per {paymentTypeText} excluding taxes.
          </li>
        </ul>
        <p>
          Your Booking Channel(s) charged per confirmed cover (no charge for
          no-show or cancellation), price ex taxes:
        </p>
        <ul>
          <li>
            MICHELIN Guide <strong>2 EUR</strong>
          </li>
          <li>
            TripAdvisor <strong>2 EUR</strong>
          </li>
          <li>
            Mozrest Audience <strong>2 EUR</strong>
          </li>
        </ul>
        <p>
          Payment and invoice processed on the{" "}
          <strong>10th of the month</strong> for the subscription of the current
          month and the covers of the previous month.
        </p>
      </>
    );
  }

  return null;
};

export default CommercialConditions;
